import { render, staticRenderFns } from "./LinkEditForm.vue?vue&type=template&id=5a34230e&"
import script from "./LinkEditForm.vue?vue&type=script&lang=js&"
export * from "./LinkEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports